import { WidgetDefinition } from "./common";
import WidgetType from "../enum/WidgetType";

const Logo: WidgetDefinition = {

    type: WidgetType.LOGO,
    className: 'widget-logo',
    contentComponent: 'dmb-widget-content-logo',

    settingsSectionComponents: [
        'dmb-section-widget-settings-logo',
        'dmb-section-widget-style',
        'dmb-section-widget-animation'
    ],

    defaultSize: {
        width: 0.2,
        height: 0.2
    },

    defaultStyle: {
        opacity: 100
    }
}

export default Logo